// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"530":"05b5e999","950":"0dde6baa"}[chunkId] + ".css";
};